
import * as ActionTypes from "../ActionTypes";

export const GetExpenseTypeAction = (params) => ({
  type: ActionTypes.EXPENSE_TYPE_GET_REQUEST,
  params,
});

export const AddExpenseTypeAction = (params, callback) => ({
  type: ActionTypes.EXPENSE_TYPE_ADD_REQUEST,
  params,
  callback
});

export const UpdateExpenseTypeAction = (params) => ({
  type: ActionTypes.EXPENSE_TYPE_UPDATE_REQUEST,
  params,
});

export const DeleteExpenseTypeAction = (params, callback) => ({
  type: ActionTypes.EXPENSE_TYPE_DELETE_REQUEST,
  params,
  callback
});

export const GetExpenseSubtypeAction = (params) => ({
  type: ActionTypes.EXPENSE_SUBTYPE_GET_REQUEST,
  params,
});

export const AddExpenseSubtypeAction = (params) => ({
  type: ActionTypes.EXPENSE_SUBTYPE_ADD_REQUEST,
  params,
});

export const UpdateExpenseSubtypeAction = (params) => ({
  type: ActionTypes.EXPENSE_SUBTYPE_UPDATE_REQUEST,
  params,
});

export const DeleteExpenseSubtypeAction = (params) => ({
  type: ActionTypes.EXPENSE_SUBTYPE_DELETE_REQUEST,
  params,
});

// employee expense
export const GetEmployeeExpenseAction = (params) => ({
  type: ActionTypes.EMPLOYEE_EXPENSE_GET_REQUEST,
  params,
});

export const AddEmployeeExpenseAction = (params, callback) => ({
  type: ActionTypes.EMPLOYEE_EXPENSE_ADD_REQUEST,
  params,
  callback
});

export const UpdateEmployeeExpenseAction = (params) => ({
  type: ActionTypes.EMPLOYEE_EXPENSE_UPDATE_REQUEST,
  params,
});

export const DeleteEmployeeExpenseAction = (params) => ({
  type: ActionTypes.EMPLOYEE_EXPENSE_DELETE_REQUEST,
  params,
});

// approver expense
export const GetApproverExpenseAction = (params) => ({
  type: ActionTypes.APPROVER_EXPENSE_GET_REQUEST ,
  params,
});

export const UpdateApproverExpenseAction = (params) => ({
  type: ActionTypes.APPROVER_EXPENSE_UPDATE_REQUEST ,
  params,
});

export const GetEmployeeExpenseCsvAction = (params) => ({
  type: ActionTypes.EMPLOYEE_EXPENSE_CSV_GET_REQUEST ,
  params,
});